import { combineReducers } from 'redux';

const initialState = {
  payPassInput: {
    checkStatus: 0,
  },
  payPassReset: {
    saveStatus: 0,
  },
};

function payPassInputReducer(state = initialState.payPassInput, action) {
  switch (action.type) {
    case 'RESET_PAY_PASS_INPUT': {
      return initialState.payPassInput;
    }

    case 'CHECK_PAY_PASS': {
      return {
        ...state,
        checkStatus: 1,
      };
    }

    case 'CHECK_PAY_PASS_COMPLETION': {
      return {
        ...state,
        checkStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

function payPassResetReducer(state = initialState.payPassReset, action) {
  switch (action.type) {
    case 'RESET_PAY_PASS': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'RESET_PAY_PASS_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  payPassInput: payPassInputReducer,
  payPassReset: payPassResetReducer,
});
